"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  en: {
    generateError: 'Request new qrcode failed',
    checkError: 'Status check failed!',
    scanned: 'Scanned Successfully',
    switchAccount: 'Regenerate QRCode',
    refresh: 'Refresh',
    open: 'Open in ABT Wallet',
    error: 'We encountered some errors when processing the request',
    oops: 'Oops',
    forbidden: 'Login user and wallet user mismatch, please logout, then login to retry'
  },
  zh: {
    generateError: '二维码生成失败',
    checkError: '扫码状态检查失败',
    scanned: '扫码成功',
    switchAccount: '重新扫码',
    refresh: '刷新',
    open: '在 ABT 钱包中打开',
    error: '服务器开小差了!',
    forbidden: '登录用户和扫码用户不匹配，为保障安全，请退出后重新登录',
    oops: '哎呀'
  }
};
exports["default"] = _default;